import axios from 'axios';

const backAxios = axios.create({
    baseURL: process.env.BACKEND_URL_SERVICES
})

export default backAxios;